export enum SpecialZoneType {
  DeadZone = 'deadZone',
  VehicleParkingZone = 'vehicleParkingZone',
  ActiveZone = 'activeZone',
  /** A named presence zone, stored server-side with its own id */
  PresenceZone = 'presenceZone',
}

export interface Point {
  x: number;
  y: number;
}

export interface ZonePolygonData {
  id: string;
  points: Point[];
  type: SpecialZoneType;
  /** Drawn inside the polygon. Presence zones are named; the others are not. */
  label?: string;
}

export interface CanvasDimensions {
  width: number;
  height: number;
}

export type HandleType = 'vertex' | 'midpoint';

export interface HandleData {
  type: HandleType;
  index: number;
  position: Point;
}
